//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import SliderPrice from "~/components/catalog/SliderPrice.vue"

export default Vue.extend({
  props: {
    filters: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedFilters: {
      type: Object,
      default() {
        return {};
      }
    },
    filterPrices: {
      type: Object,
      default() {
        return {};
      }
    },
    category: {
      type: Object,
      default() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opened: ''
    };
  },
  components: {
    SliderPrice,

    FilterRangeFrameSize: () => import("~/components/filters/FilterRangeFrameSize.vue")
  },
  computed: {
    pol() {
      return this.filters.find((filter) => {
        if (filter.name === 'Пол') {
          return filter;
        }
      });
    },
    selected() {
      const filtersInit = [...this.filtersDefault];
      const selectedFilters = {...this.selectedFilters};
      const filters = [];

      Object.keys(selectedFilters).map((filterKey) => {
        const filterItem = filtersInit.find(t => t.slug === filterKey);
        const selected = selectedFilters[filterKey];


        if (!!filterItem) {
          Object.keys(selected).map((variantKey) => {
            const variant = filterItem.variants.find(t => String(t.slug) === String(variantKey));
            let variantLabel = variant?.label;
            if (filterKey === 'new') {
              variantLabel = 'Новинки'
            }

            if (variant && filterKey !== 'pol') {
              filters.push({
                slug: filterKey,
                variant: {
                  ...variant,
                  label: variantLabel
                }
              });
            }
          });
        }
      });

      return filters;
    },
    isShowFilterReset() {
      if (this.opened && Object.keys(this.selectedFilters[this.opened] || {}).length > 0) {
        return true;
      }

      return false;
    },
    sexAllActive() {
      return !Boolean(this.$route.path.indexOf('pol=') > -1)
    },

    labelFilterPrice: function () {
      let priceFrom = +(Object.keys(this.selectedFilters?.priceFrom || {})?.[0] || null);
      let priceTo = +(Object.keys(this.selectedFilters?.priceTo || {})?.[0] || null);

      if (!priceFrom && !priceTo) {
        return ''
      }

      return `Цена: ${this.$numberFormat(priceFrom)} ₽ — ${this.$numberFormat(priceTo)} ₽`
    },

    opravyImagePlug: function () {
      const form = (this.filters || []).find((t) => t.slug === "form");
      const variants = form?.variants || [];
      const variant = variants.find((t) => t.slug === "aviator") || variants?.[0] || null;
      const variantImageId = variant?.imageId || 22003;

      return String(variantImageId)
    },

    filtersDefault: function () {
      return [...(this.filters || [])]
        .filter((t) => {
          return Boolean(t.filterTemplate !== 'range_frame_size')
        })
    },

    filtersRangeFrameSize: function () {
      return [...(this.filters || [])]
        .filter((t) => {
          return Boolean(t.filterTemplate === 'range_frame_size')
        })
    },
    selectedRangeFrameSize: function () {
      const filtersInit = [...this.filtersDefault];
      const selectedFilters = {...this.selectedFilters};
      const filters = [];

      Object.keys(selectedFilters).map((filterKey) => {
        const selectedFilter = this.filtersRangeFrameSize.find((t) => t.slug === filterKey);
        const selected = selectedFilters[filterKey];
        if (selectedFilter) {
          const [startValue, endValue] = (Object.keys(selected)?.[0] || '').split(":");
          filters.push({
            slug: filterKey,
            variant: {
              label: `${selectedFilter.name}: от ${startValue} до ${endValue}`
            },
            type: 'rangeFrameSize'
          });
        }
      });

      return filters;
    },
    isSelectedRangeFrameSize: function () {
      return Boolean(this.filtersRangeFrameSize.find((t) => this.selectedFilters[t.slug]));
    },

    visibleFilterNew: function () {
      return Boolean((this.filters || []).find((t) => t.slug === "new"))
    },
    isSelectedFilterNew: function () {
      return Boolean(this.selectedFilters?.['new'])
    },
  },
  methods: {
    checkAvailable(variant, availables) {
      return Boolean(availables.indexOf(variant.slug));
    },

    isSelected(variant, filter) {
      if (!this.selectedFilters[filter]) {
        return false;
      }

      return Boolean(this.selectedFilters[filter][variant]);
    },

    onChangeSex(variant, filter) {
      if (
        !this.selectedFilters[filter] ||
        this.selectedFilters[filter].includes(variant)
      ) {
        this.$emit('onChangeFilterVariant', filter, variant);

        return null;
      }

      this.$emit('onChangeFilterVariant', filter, this.selectedFilters[filter][0]);
      this.$emit('onChangeFilterVariant', filter, variant);
    },

    onResetFilterName() {
      this.$emit('onResetFilterSlug', this.opened);
    },

    isDisabledFilterVariant(filter, variant) {
      return !filter.available.includes(variant);
    },

    changePrice: function (prices) {
      this.$emit('onChangeFilterVariantPrice', [
        {filterSlug: 'priceFrom', variantSlug: prices[0]},
        {filterSlug: 'priceTo', variantSlug: prices[1]},
      ]);
    },

    getSelectedPrice: function () {
      let priceFrom = +(Object.keys(this.selectedFilters?.priceFrom || {})?.[0] || -1);
      let priceTo = +(Object.keys(this.selectedFilters?.priceTo || {})?.[0] || -1);

      return [priceFrom, priceTo]
    },

    removeFilterPrice: function () {
      this.$emit('onRemoveFilterVariantPrice');
    },


    changeFilterSlug: function (filterSlug, value) {
      let selectedFilters = {...this.selectedFilters};
      if (!value) {
        delete selectedFilters[filterSlug]
      } else {
        selectedFilters[filterSlug] = value;
      }
      this.$emit('searchProducts', selectedFilters);
    },
  }
});
